module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.inspiration', {
            url: '/discover?{name}&{cardId:int}',
            resolve: {
                navigationItems: ['InspirationService', function (inspirationService) {
                    return inspirationService.getNavigationItems();
                }],
            },
            onEnter: ['$state', '$timeout', 'FeatureService', 'navigationItems', function ($state, $timeout, featureService, navigationItems) {
                if (featureService.isEnabled(featureService.features.enableDiscoverLandingPage)) { return; }

                $state.transition.then(() => {
                    if ($state.is('shop.inspiration')) {
                        $state.go('shop.inspiration.parent', { parent: navigationItems[0].UrlPart }, { location: 'replace' });
                    }
                });
            }],
            views: {
                'left-panel@shop': {
                    controller: [
                        'navigationItems', function (navigationItems) {
                            this.menuItems = navigationItems;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: '<wow-inspiration-navigation ng-if="!$breakpoints.isInSmallFormat" menu-items="$ctrl.menuItems"></wow-inspiration-navigation>',
                },
            },
            data: {
                pageMetadata: [
                    'PageMetadataService', function (pageMetadataService) {
                        return pageMetadataService.getMetadata({ name: 'Discover - Woolworths Online' });
                    },
                ],
            },
        })
        .state('shop.inspirationcard', {
            url: '/discover/card/{id}?name',
            views: {
                'center-panel@shop': {
                    template: '<wow-loading-spinner></wow-loading-spinner>',
                },
                'left-panel@shop': {
                    controller: [
                        '$state', '$stateParams', 'InspirationService', function ($state, $stateParams, inspirationService) {
                            inspirationService.getDiscoverPathForCard($stateParams.id).then((pathToCard) => {
                                if (pathToCard.Page === null || pathToCard.Page.Parent === null) {
                                    $state.go('error.404', null, { location: 'replace' });
                                }

                                $state.go('shop.inspiration.parent.child', {
                                    parent: pathToCard.Parent.Page.UrlPart,
                                    child: pathToCard.Page.UrlPart,
                                    cardId: $stateParams.id,
                                    name: $stateParams.name,
                                },
                                {
                                    location: 'replace',
                                });
                            });
                        },
                    ],
                },
            },
        })
        .state('shop.inspiration.parent', {
            url: '/:parent',
            reloadOnSearch: false,
            views: {
                'center-panel@shop': {
                    controller: [
                        '$state', function ($state) {
                            this.$state = $state;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-inspiration-detail-tile-list
                            page-id="$ctrl.$state.params.parent">
                        </wow-inspiration-detail-tile-list>
                    `,
                },
            },
        })
        .state('shop.inspiration.parent.child', {
            url: '/:child',
            reloadOnSearch: false,
            views: {
                'center-panel@shop': {
                    controller: [
                        '$state', function ($state) {
                            this.$state = $state;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-inspiration-detail-tile-list
                            page-id="$ctrl.$state.params.child">
                        </wow-inspiration-detail-tile-list>
                    `,
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/inspiration.js